
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3c9.714 0 12 9.529 12 9.529S20.571 21 12 21 0 12.529 0 12.529 2.286 3 12 3zm0 3c-3.577 0-6.476 2.687-6.476 6S8.423 18 12 18s6.476-2.687 6.476-6S15.577 6 12 6zm0 2a4 4 0 110 8 4 4 0 010-8z","fill":"#2A333D"}})])
          )
        }
      }
    